import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "v-input" }
const _hoisted_2 = { class: "v-input__control" }
const _hoisted_3 = { class: "v-input__slot" }
const _hoisted_4 = {
  key: 1,
  class: "text-error"
}
const _hoisted_5 = {
  key: 0,
  class: "v-text-field__details"
}
const _hoisted_6 = { class: "v-messages theme--light text-error" }
const _hoisted_7 = { class: "v-messages__wrapper" }
const _hoisted_8 = { class: "v-messages__message" }

import { useField } from 'vee-validate';
import { toRef, watch } from 'vue';
import { VueRecaptcha } from 'vue-recaptcha';

type Props = {
    rules: string | Record<string, unknown>;
    required: boolean;
    modelValue: string | null;
    name: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'CaptchaField',
  props: {
    rules: {},
    required: { type: Boolean },
    modelValue: {},
    name: {}
  },
  setup(__props: any) {

const props = __props;

const rulesRef = toRef(props, 'rules');

const { value, errors, resetField } = useField(() => props.name, rulesRef, {
    syncVModel: true
});

watch(value, () => {
    resetField();
});

function onCaptchaVerified (token: string) {
    value.value = token;
}

function onCaptchaExpired () {
    value.value = null;
}

function onCaptchaError () {
    value.value = null;
}

const siteKey = process.env.VUE_APP_CAPTCHA_SITEKEY;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(siteKey))
          ? (_openBlock(), _createBlock(_unref(VueRecaptcha), {
              key: 0,
              sitekey: _unref(siteKey),
              onVerify: onCaptchaVerified,
              onExpired: onCaptchaExpired,
              onError: onCaptchaError
            }, null, 8, ["sitekey"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('form.captchaSitekey')), 1))
      ]),
      (_unref(errors)?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(errors)?.[0]), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})